import React, {PureComponent} from "react"
import {get} from "lodash"

import Pill from "@irati/ui/src/Pill"
import {Team} from "@irati/admin/types"
import id from "@irati/utils/id"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

import {HIGHEST_COLOR, LOWEST_COLOR} from "./colors"
import {Container} from "./styled"

interface Props {
  row: Team
  loggedInRateAccessor: string
  highestRate: string
  lowestRate: string
}

class LoggedInRateRenderer extends PureComponent<Props> {
  render() {
    const idNamespace = id("TeamsRenderer", this.props)
    const {row, loggedInRateAccessor, highestRate, lowestRate} = this.props
    const loggedInRate = get(row, loggedInRateAccessor)
    const isHighestRow = get(row, highestRate, false)
    const isLowestRow = get(row, lowestRate, false)

    return (
      <Flex id={idNamespace}>
        <Container width={50}>{`${Math.round(loggedInRate)} %`}</Container>
        {isHighestRow && <Pill text={<FormattedMessage id="admin.reporting.loggedInRate.highest" />} color={HIGHEST_COLOR} />}
        {isLowestRow && <Pill text={<FormattedMessage id="admin.reporting.loggedInRate.lowest" />} color={LOWEST_COLOR} />}
      </Flex>
    )
  }
}

export default LoggedInRateRenderer
